module.exports = __webpack_public_path__ + "img/martin-pro.9e1d78e4.jpg";